import React from 'react';
import { PackageCheck, AlertCircle, Clock, FileCheck, Truck, RefreshCw, Phone, Mail, MapPin } from 'lucide-react';
import './ReturnPolicy.css';

const ReturnPolicy = () => {
  return (
    <>
      <div className="policy-page-container">
        <div className="policy-page-wrapper">
          <h1 className="policy-page-title">Return Policy</h1>
          
          <div className="policy-page-intro">
            <PackageCheck className="page-intro-icon" />
            <p>
              At <strong>PROPERTECK</strong>, we aim to provide the best quality products and reliable service to all our customers. This Return Policy applies to both Personal and Corporate customers purchasing from us through our physical store or online platform.
            </p>
          </div>

          <div className="policy-page-content">
            <div className="policy-page-section">
              <h2 className="policy-section-title"><FileCheck className="policy-section-icon" /> Eligibility for Returns</h2>
              <p className="policy-section-description">Returns are accepted only for damaged, defective, or incorrect items received from PROPERTECK.</p>

              <ul className="policy-list">
                <li>Products must be reported for return within <strong>3 days</strong> from the date of delivery / collection.</li>
                <li>Products must be in the original packaging, with all accessories, manuals, and proof of purchase (invoice or receipt).</li>
              </ul>

              <div className="policy-subsection">
                <h3 className="policy-subsection-title"><AlertCircle className="policy-subsection-icon" /> Returns will NOT be accepted for:</h3>
                <ul className="policy-list">
                  <li>Products that are not defective or damaged.</li>
                  <li>Products damaged due to customer mishandling, misuse, or improper installation.</li>
                  <li>Software, digital licenses, or consumable items once activated/opened.</li>
                </ul>
              </div>
            </div>

            <div className="policy-page-section">
              <h2 className="policy-section-title"><RefreshCw className="policy-section-icon" /> Return Process</h2>
              <p className="policy-section-description">Follow these steps to initiate a return:</p>
              
              <ol className="policy-ordered-list">
                <li>Contact our customer support team via phone or email (details below).</li>
                <li>Provide the order number, invoice, and details of the damaged product with clear photos or videos as proof.</li>
                <li>Our team will verify your request and provide return instructions.</li>
                <li>Approved returns must be sent or brought to our store at the address below.</li>
              </ol>

              <div className="policy-info-box">
                <MapPin className="info-box-icon" />
                <div>
                  <p className="info-box-title">Store Location</p>
                  <p>No. 49/6, 1st Floor, Near the Bus Stand, Giriulla.</p>
                </div>
              </div>
            </div>

            <div className="policy-page-section">
              <h2 className="policy-section-title"><FileCheck className="policy-section-icon" /> Inspection & Approval</h2>
              <p className="policy-section-description">All returned items will be inspected before approval.</p>
              
              <ul className="policy-list">
                <li>If the product is confirmed to be defective or damaged during delivery, we will:
                  <ul className="policy-nested-list">
                    <li>Replace the item with a new one (subject to stock availability), or</li>
                    <li>Issue a full refund via the original payment method.</li>
                  </ul>
                </li>
                <li>If the product is found to be in good condition or damaged due to customer error, the return request will be declined.</li>
              </ul>
            </div>

            <div className="policy-page-section">
              <h2 className="policy-section-title"><Clock className="policy-section-icon" /> Refunds</h2>
              <ul className="policy-list">
                <li>Refunds will be processed within <strong>07–14 business days</strong> after the returned product has been received and inspected.</li>
                <li>Shipping or delivery fees are non-refundable unless the return is due to our error.</li>
              </ul>
            </div>

            <div className="policy-page-section">
              <h2 className="policy-section-title"><Truck className="policy-section-icon" /> Additional Notes</h2>
              <ul className="policy-list">
                <li>For corporate customers, bulk order returns will be handled on a case-by-case basis following the same inspection process.</li>
                <li>PROPERTECK reserves the right to update or modify this Return Policy at any time without prior notice.</li>
              </ul>
            </div>

            <div className="policy-page-section policy-contact-section">
              <h2 className="policy-section-title">Contact Us</h2>
              <p>For return requests or any questions, please contact us:</p>
              <div className="policy-contact-details">
                <p><Phone className="policy-contact-icon" /> 077 949 0055 / 037 434 0055</p>
                <p><Mail className="policy-contact-icon" /> info@properteck.lk</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReturnPolicy;